<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">Organisation with this registry ID is already registered in Public Procurement Gateway</p>
  <p><a id="searchWithDifferentIdLink" routerLink="/manage-org/register/search">Search with a different organisation ID</a></p>
  <p><a id="contactCCSLink" href="https://www.gca.gov.uk/contact" target="_blank">Contact GCA</a></p>
</div>
